export default "__VITE_ASSET__CIUqScD5__"